import React, { useEffect, useState } from "react";
import api from "../utils/api";

// Who can take live chats right now: Online agents (switch + admin app open) and their open chats vs the limit.
const REFRESH_MS = 60000;

const TeamAvailability = () => {
  const [team, setTeam] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .get("/live-chat/agents", { skipToast: true })
        .then((res) => alive && setTeam(res))
        .catch(() => {});
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  if (!team || !team.agents) return null;
  const total = team.agents.length;

  return (
    <div style={{ padding: "10px 12px", borderBottom: "1px solid #e4e4e7", background: "#fafafa" }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer" }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", fontWeight: 600, color: "#3f3f46" }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: team.online_count > 0 ? "#10b981" : "#a1a1aa" }} />
          {team.online_count} of {total} agents online
        </span>
        <span style={{ fontSize: "10px", color: "#a1a1aa", fontWeight: 600 }}>{open ? "Hide" : "Show"}</span>
      </button>
      {open && (
        <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "4px" }}>
          {team.agents.map((a) => (
            <div key={a.user_id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "11px", color: "#3f3f46" }}>
              <span style={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0 }}>
                <span style={{ width: 6, height: 6, borderRadius: "50%", flexShrink: 0, background: a.online ? "#10b981" : "#d4d4d8" }} />
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {a.name}
                  {a.is_me ? " (you)" : ""}
                </span>
              </span>
              <span style={{ color: a.at_capacity ? "#b45309" : "#a1a1aa", fontWeight: 600, flexShrink: 0 }}>
                {a.open_chats}
                {a.max_chats ? `/${a.max_chats}` : ""} chats
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamAvailability;
